import { DataService } from '../../services/data.service';
import { observable, action, } from 'mobx';
import { Injectable } from '@angular/core';
import { pushToObject, pushToArray } from 'src/app/services/mapping.service';
import { APPS } from 'src/app/dummy/app';
import { IRegisterTesting, IRegisterTestingResult } from 'src/app/interfaces/enrollment';

@Injectable()
export class RegisterTesting {
    @observable data: any[] = [];
    @observable process: boolean = false;
    @observable loading: boolean = true;
    @observable empty: boolean = false;
    @observable fetching: boolean = false;
    @observable selectedClass: any = null;
    @observable lastVisible: any = null;

    constructor(private ds: DataService) { }

    @action
    async fetchClassroom(classroomKey) {
        const docs = await this.ds.classRoomRef().doc(classroomKey).get().toPromise();
        this.selectedClass = pushToObject(docs);
        return this.selectedClass;
    }

    @action
    async fetchAdmission(organizationKey) {
        this.loading = true;
        const docs = await this.ds.admissionRef(this.lastVisible, organizationKey).get().toPromise();
        this.data = pushToArray(docs);
        this.empty = docs.empty;
        if (docs.size > 0 && docs.size >= APPS.SIZE) {
            this.lastVisible = this.data[docs.size - 1];
        } else {
            this.lastVisible = null;
        }
        this.loading = false;
    }


    @action
    async fetchData(organizationKey, termKey, programKey) {
        this.loading = true;
        const docs = await this.ds.registerTestRef(this.lastVisible, organizationKey, termKey, programKey).get().toPromise();
        this.data = pushToArray(docs);
        this.empty = docs.empty;
        if (docs.size > 0 && docs.size >= APPS.SIZE) {
            this.lastVisible = this.data[docs.size - 1];
        } else {
            this.lastVisible = null;
        }
        this.loading = false;
    }

    @action
    save(item: IRegisterTesting, callback) {
        this.process = true;
        const batch = this.ds.batch();
        const testingRef = this.ds.companyFireRef().doc(item.organizationKey);
        const movementRef = this.ds.registerTestFireRef().doc(item.key);
        const studentRef = this.ds.studentFireRef().doc(item.key);
        batch.set(testingRef.collection('terms').doc(item.termKey).collection('general_register_testing').doc(item.key), item);
        batch.set(movementRef, item);
        batch.set(studentRef, item);
        batch.set(studentRef, {
            ...item,
            displayName: item.fullName,
            phoneNumber: `${item.phone}`,
            isTeacher: false,
            generalPlacementTestKey: item.key,
            generalPlacementTestStarting: true,
            generalPlacementTestCompleted: false,
        });
        batch.set(studentRef.collection('general_register_testing').doc(item.key), item);
        batch.set(studentRef.collection('general_register_testing').doc(item.key), item);
        batch.set(studentRef.collection('general_placement_test').doc(item.key), {
            key: item.key,
            starting: false,
            time: APPS.PLACEMENT_TEST_DURATION,
        })
        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    setResult(item: IRegisterTestingResult, testing: IRegisterTesting, callback) {
        this.process = true;
        const batch = this.ds.batch();
        const testingRef = this.ds.companyFireRef().doc(item.organizationKey);
        const studentRef = this.ds.studentFireRef().doc(testing.studentKey);
        batch.update(testingRef
            .collection('terms').doc(testing.termKey)
            .collection('general_register_testing').doc(testing.studentKey), { result: item });
        batch.update(studentRef, { result: item });
        batch.update(studentRef.collection('general_register_testing').doc(testing.key), { result: item });
        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }
}
